import { render, staticRenderFns } from "./ElPostInfo.vue?vue&type=template&id=1d0838be"
import script from "./ElPostInfo.vue?vue&type=script&lang=js"
export * from "./ElPostInfo.vue?vue&type=script&lang=js"
import style0 from "./ElPostInfo.vue?vue&type=style&index=0&id=1d0838be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports